import Firebase from 'firebase/app';
import credentials from './firebase.config';
import store from '../store';

const App = Firebase.initializeApp(credentials.config);

App.getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = Firebase.auth().onAuthStateChanged(user => {
      unsubscribe();
      resolve(user);
      if (!user) return;
      //if (!user.emailVerified) return;
      if (store.getters.currentUser) return;

      store.dispatch('login', {
        isAuthenticated: true,
        user,
      });
    }, reject);
  });
};

export default App;
